import { defineComponent as _defineComponent } from 'vue'
import {
  MissionLifecycleFragmentFragment,
  ConsultantMissionLifecycle,
  ClientMissionLifecycleFragmentFragment,
} from "@/gql"

import ActivityTimeline from "@/components/widgets/timeline/ActivityTimeline.vue"
import ExpansionPanels from "@/components/widgets/accordion/ExpansionPanels.vue"
import ExpansionPanel from "@/components/widgets/accordion/ExpansionPanel.vue"
import ExpansionHeader from "@/components/widgets/accordion/ExpansionHeader.vue"
import ExpansionContent from "@/components/widgets/accordion/ExpansionContent.vue"
import Badge from "@/components/widgets/common/Badge.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivitySummary',
  props: {
    mission: null
  },
  setup(__props: any) {



return { __sfc: true,ActivityTimeline, ExpansionPanels, ExpansionPanel, ExpansionHeader, ExpansionContent, Badge }
}

})